import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { Status } from '../../@types/status'
import { Resource } from '../../@types/resource'
import { fetchPlaceDetail } from './thunks'
import { Address } from '../../@types/address'

export const initialState: Resource<Address> = { status: Status.LOADING }

const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    updateStreet: (state, action: PayloadAction<string | undefined>) => {
      if (!state.data) state.data = {}
      state.data.street = action.payload
    },
    updateHouseNumber: (state, action: PayloadAction<string | undefined>) => {
      if (!state.data) state.data = {}
      state.data.houseNumber = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPlaceDetail.fulfilled, (state, action) => {
      return {
        status: Status.SUCCESS,
        data: {
          street: action.payload.street,
          houseNumber: action.payload.houseNumber || state.data?.houseNumber,
        },
      }
    })
    builder.addCase(fetchPlaceDetail.pending, (state) => {
      return {
        status: Status.LOADING,
        data: {
          houseNumber: state.data?.houseNumber,
        },
      }
    })
    builder.addCase(fetchPlaceDetail.rejected, (state) => {
      return {
        status: Status.ERROR,
        data: {
          houseNumber: state.data?.houseNumber,
        },
      }
    })
  },
})

export const { updateStreet, updateHouseNumber } = addressSlice.actions

export default addressSlice.reducer
